export default "__VITE_ASSET__2510f03c__"